export const SRP_TYPES = {
  DEFAULT: 'DEFAULT',
  API_OVERRIDE: 'API_OVERRIDE',
  BRAND: 'BRAND',
  DISCOUNTS: 'DISCOUNTS',
};
